import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {
    DETAILS_PAGE_ROUTE,
    EXPORT_PDF_PAGE_RESIDENTIAL_ROUTE,
    EXPORT_PDF_PAGE_COMMERCIAL_ROUTE,
    LANDING_PAGE_ROUTE,
    RESIDENTIAL_INCENTIVES_DETAILS_PAGE_ROUTE,
} from './constants/Routes';
import IncentiveDetails from './views/IncentiveDetails/IncentiveDetails';
import LandingPage from './views/LandingPage/LandingPage';
import { defaultTheme } from '@cxc/react-fpds-foundation';
import { ThemeProvider } from '@cxc/react-fpds-components';
import Disclosure from './components/Disclosure/Disclosure';
import ResidentialIncentiveDetails from './views/ResidentialIncentiveDetails/ResidentialIncentiveDetails';
import PDFReportDocument from './components/ReportGenerator/PDFReportDocument';
import PDFReportDocumentResidential from './components/ReportGenerator/Residential/PDFReportDocumentResidential';

const App = (): React.JSX.Element => {
    return (
        <ThemeProvider theme={defaultTheme}>
            <Routes>
                <Route path={LANDING_PAGE_ROUTE} element={<LandingPage />} />
                <Route path={DETAILS_PAGE_ROUTE} element={<IncentiveDetails />} />
                <Route
                    path={RESIDENTIAL_INCENTIVES_DETAILS_PAGE_ROUTE}
                    element={<ResidentialIncentiveDetails />}
                />
                <Route path={EXPORT_PDF_PAGE_COMMERCIAL_ROUTE} element={<PDFReportDocument />} />
                <Route
                    path={EXPORT_PDF_PAGE_RESIDENTIAL_ROUTE}
                    element={<PDFReportDocumentResidential />}
                />
            </Routes>
            <Disclosure />
        </ThemeProvider>
    );
};

export default App;
